<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mobileRem } from "@/common/rem";
import { AppDeviceEnquire } from "@/utils/mixin";
import { initTheme, watchSystemTheme, watchStorage } from "@/utils/theme";
import { setStorage } from "@/utils";
export default {
  mixins: [AppDeviceEnquire],
  components: {},
  data() {
    return {};
  },
  created() {
    // 统一主题入口：初始化 + 监听系统偏好/多标签同步
    const theme = initTheme();
    this.$store.dispatch("updateTheme", theme);
    this._stopSystemThemeWatch = watchSystemTheme((t) => this.$store.dispatch("syncTheme", t));
    this._stopStorageWatch = watchStorage((t) => this.$store.dispatch("syncTheme", t));
    mobileRem();
    // 捕获邀请链接里的 ?ref= 参数（推广体系：落地即记录，链上绑定在用户首次交易时完成）
    this.captureRef(this.$route.query.ref);
  },
  watch: {
    "$route.query.ref"(value) {
      this.captureRef(value);
    },
  },
  beforeDestroy() {
    this._stopSystemThemeWatch && this._stopSystemThemeWatch();
    this._stopStorageWatch && this._stopStorageWatch();
  },
  methods: {
    captureRef(value) {
      if (value && /^0x[0-9a-fA-F]{40}$/.test(String(value))) {
        setStorage("prediReferrer", String(value).toLowerCase());
      }
    },
  },
};
</script>

